module.exports = __webpack_public_path__ + "img/Rogue-bloodelf-f-70.2517ec52.gif";